export const france = {
  slug: "france",
  name: "France",
  flag: "🇫🇷",
  tagline: "World-Class Education with Affordable Tuition",
  heroImg: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#1E4FA1",
  students: "35+",
  avgTuition: "€2,770–€6,000/yr",
  avgLiving: "€800–€1,300/mo",
  workPermit: "2 years post-study",
  ieltsReq: "6.0+",
  intakeMonths: ["September", "January"],
  overview:
    "France offers globally respected universities, business schools, and engineering institutes with affordable tuition, rich culture, and growing English-taught programmes.",
  whyChoose: [
    { icon: "🎓", title: "Affordable Education", desc: "Lower tuition fees compared to UK, USA, and Australia." },
    { icon: "🏛️", title: "Prestigious Institutions", desc: "Home to Sorbonne, HEC Paris, INSEAD and top Grandes Écoles." },
    { icon: "🌐", title: "English Programmes", desc: "Thousands of English-taught programmes available." },
    { icon: "📋", title: "Post-Study Work", desc: "Master’s graduates can stay up to 2 years after study." },
    { icon: "🍷", title: "Culture & Lifestyle", desc: "Historic cities, art, cuisine, and strong student life." },
    { icon: "🤝", title: "EU Career Access", desc: "Strong gateway to jobs across Europe." },
  ],
  process: [
    { step: "01", title: "Course Selection", desc: "Choose university or Grande École programme." },
    { step: "02", title: "Campus France", desc: "Complete Campus France procedure where required." },
    { step: "03", title: "Visa Application", desc: "Apply for long-stay student visa." },
    { step: "04", title: "Arrival", desc: "Validate visa and complete local registration." },
  ],
  universities: [
    "sorbonne","psl","hec-paris","insead","ecole-polytechnique",
    "grenoble","lyon","paris-saclay","lille","strasbourg"
  ],
  stats: [
    { n: "35+", label: "Students Placed" },
    { n: "€2.7k", label: "Min Tuition/yr" },
    { n: "93%", label: "Visa Success" },
    { n: "2yr", label: "Post-Study Permit" },
  ],
};